import { render, staticRenderFns } from "./BusPlanningSendHistoryModal.vue?vue&type=template&id=71bc1ce0&"
import script from "./BusPlanningSendHistoryModal.vue?vue&type=script&lang=js&"
export * from "./BusPlanningSendHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports